import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=5a38149a&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"
import style0 from "./Popover.vue?vue&type=style&index=0&id=5a38149a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38149a",
  null
  
)

export default component.exports